module.exports = __webpack_public_path__ + "static/media/55_000036.1c63a65b.jpg";